import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1db1640a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loading" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading_ring" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading_icon" }, null, -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

import { storeToRefs } from 'pinia';
import { useBase } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'Loading',
  setup(__props) {

const { isLoading } = storeToRefs(useBase());

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4, 512)), [
    [_vShow, _unref(isLoading)]
  ])
}
}

})